export default __webpack_public_path__ + "static/media/clobber3.f9b54872.png";